import { render, staticRenderFns } from "./BrowserPage.vue?vue&type=template&id=5d297fa8"
import script from "./BrowserPage.vue?vue&type=script&lang=js"
export * from "./BrowserPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports